// Sidebar navigation groups: collapse/expand with the chevron in the group
// label. State is kept per browser (localStorage); the group that holds the
// active page always opens so the current location stays visible.
//
//   <nav class="app-nav" data-controller="nav-groups">
//     <div class="app-nav__group" data-nav-groups-target="group" data-nav-group="forecasting">
//       <button class="app-nav__group-label" data-action="nav-groups#toggle">…</button>
//       <div class="app-nav__links">…</div>
import { Controller } from '@hotwired/stimulus'

const KEY = 'aim_nav_collapsed'

export default class extends Controller {
  static targets = ['group']

  connect () {
    this.apply()
  }

  toggle (event) {
    const group = event.currentTarget.closest('[data-nav-group]')
    if (!group) return
    const key = group.dataset.navGroup
    const collapsed = this.read().filter((k) => k !== key)
    const nowCollapsed = !group.classList.contains('is-collapsed')
    if (nowCollapsed) collapsed.push(key)
    this.write(collapsed)
    this.set(group, nowCollapsed)
  }

  apply () {
    const collapsed = this.read()
    this.groupTargets.forEach((group) => {
      const key = group.dataset.navGroup
      const hasActive = !!group.querySelector('.app-nav__link.is-active')
      this.set(group, collapsed.includes(key) && !hasActive)
    })
  }

  set (group, collapsed) {
    group.classList.toggle('is-collapsed', collapsed)
    const btn = group.querySelector('.app-nav__group-label')
    if (btn) btn.setAttribute('aria-expanded', collapsed ? 'false' : 'true')
  }

  read () {
    try { return JSON.parse(window.localStorage.getItem(KEY) || '[]') } catch (e) { return [] }
  }

  write (arr) {
    try { window.localStorage.setItem(KEY, JSON.stringify(arr)) } catch (e) { /* private mode */ }
  }
}
